module.exports = __webpack_public_path__ + "img/header-memoireRingsGrowingMemoires.c279cb0.jpg";